import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-83be0954")

_pushScopeId("data-v-83be0954")
const _hoisted_1 = { class: "fridgemyassistediting-page" }
const _hoisted_2 = {
  key: 0,
  class: "fridgemyassistediting-page-contents"
}
const _hoisted_3 = { class: "fridgemyassistediting-page-contents-contents" }
const _hoisted_4 = { class: "fridgemyassistediting-page-contents-contents-listtitle" }
const _hoisted_5 = { class: "fridgemyassistediting-page-contents-contents-listtitle-title" }
const _hoisted_6 = { class: "fridgemyassistediting-page-contents-contents-listtitle-title-text" }
const _hoisted_7 = { class: "fridgemyassistediting-page-contents-contents-listtitle-input" }
const _hoisted_8 = { class: "fridgemyassistediting-page-contents-contents-course" }
const _hoisted_9 = { class: "fridgemyassistediting-page-contents-contents-course-title" }
const _hoisted_10 = { class: "fridgemyassistediting-page-contents-contents-course-title-text" }
const _hoisted_11 = { class: "fridgemyassistediting-page-contents-contents-course-kind" }
const _hoisted_12 = { class: "fridgemyassistediting-page-contents-contents-settingtime" }
const _hoisted_13 = { class: "fridgemyassistediting-page-contents-contents-settingtime-title" }
const _hoisted_14 = { class: "fridgemyassistediting-page-contents-contents-settingtime-title-text" }
const _hoisted_15 = { class: "fridgemyassistediting-page-contents-contents-settingtime-drum" }
const _hoisted_16 = {
  key: 1,
  class: "fridgemyassistediting-page-bottom"
}
const _hoisted_17 = { class: "fridgemyassistediting-page-bottom-button-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsRadioButton = _resolveComponent("FridgeDetailsRadioButton")
  const _component_FridgeDetailsDrumPicker = _resolveComponent("FridgeDetailsDrumPicker")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isValidContents)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, _toDisplayString(_ctx.listTitleText), 1)
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("input", {
                  type: "text",
                  ref: "textInput",
                  class: "fridgemyassistediting-page-contents-contents-listtitle-input-form",
                  maxlength: _ctx.textMaxLength,
                  value: _ctx.currentSetting.nickname
                }, null, 8, ["maxlength", "value"])
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("span", _hoisted_10, _toDisplayString(_ctx.courseTitleText), 1)
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_FridgeDetailsRadioButton, {
                  class: "fridgemyassistediting-page-contents-contents-course-kind-radiobutton",
                  key: _ctx.updateDisplayKey,
                  labels: _ctx.kindTitleLabels,
                  initialSelectIndex: _ctx.initialIndexKind,
                  onSelectChange: _ctx.kindChange
                }, null, 8, ["labels", "initialSelectIndex", "onSelectChange"])
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode("span", _hoisted_14, _toDisplayString(_ctx.settingTimeTitleText), 1)
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode(_component_FridgeDetailsDrumPicker, {
                  key: _ctx.updateDisplayKey,
                  minutesLowerLimit: _ctx.currentLimitParameter.lowerLimitMinutes,
                  minutesUpperLimit: _ctx.currentLimitParameter.upperLimitMinutes,
                  initialMinutes: _ctx.currentSetting.cooloven_time,
                  isValidSeconds: _ctx.currentSetting.valid_second,
                  secondsLowerLimit: _ctx.currentLimitParameter.lowerLimitSeconds,
                  secondsUpperLimit: _ctx.currentLimitParameter.upperLimitSeconds,
                  initialSeconds: _ctx.currentSetting.cooloven_second,
                  onSelectTime: _ctx.selectTime
                }, null, 8, ["minutesLowerLimit", "minutesUpperLimit", "initialMinutes", "isValidSeconds", "secondsLowerLimit", "secondsUpperLimit", "initialSeconds", "onSelectTime"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isValidContents)
      ? (_openBlock(), _createBlock("div", _hoisted_16, [
          _createVNode("div", {
            class: "fridgemyassistediting-page-bottom-button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveButtonAction(...args)))
          }, [
            _createVNode("span", _hoisted_17, _toDisplayString(_ctx.saveButtonText), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"])
  ]))
})